/**
 * One mutable mock "database" shared by the four services, so a role assigned in
 * `membersService` shows up in `rolesService`, a studio grant respects the
 * member's roles, etc. Each service's `__resetMock…ForTests()` resets ALL of it.
 *
 * TODO(CT-5563 / backend): replaced by the real People & Access endpoints.
 */
import { buildSeedGroups } from './groups.js';
import { buildSeedMemberResources } from './memberAccess.js';
import { buildSeedMembers } from './members.js';
import { buildSeedRoles } from './roles.js';
import { buildSeedStudios } from './studios.js';

export const store = {
  members: [],
  roles: [],
  groups: [],
  studios: [],
  /** member_id → [{ permission_id, level }] — grants pinned directly on a member. */
  directGrants: {},
  /** member_id → [studio_id] — studios granted directly, even with no permission set yet. */
  studioAccess: {},
  /** member_id → resources (datasets, models, event buses, sandboxes) the member reaches, one row per access path. */
  memberResources: {},
  /** member_id → role_id → { assigned_by, assigned_at }: who gave the role and when (seeded roles use a default). */
  roleAssignments: {},
  /** Import batches registered by bulk creates, newest first: { id, file_name, created_at }. */
  importBatches: [],
  seq: 0,
};

/**
 * Direct grants and direct studio access of a few seeded members, so the Studios tab shows Direct
 * and Pinned rows and Remove access without saving anything first:
 * - Sebastián Blanco (Developer + Agent Builder): a new direct permission and one pinned over a role.
 * - Andrés Morales (no roles): Data Studio granted only directly.
 */
const buildSeedDirectGrants = () => ({
  'mbr-016': [
    { permission_id: 'governance.drives.upload', level: 'groups' },
    { permission_id: 'governance.sandboxes.view', level: 'tenant' },
  ],
  'mbr-006': [{ permission_id: 'data.datasets.view', level: 'own' }],
});

const buildSeedStudioAccess = () => ({ 'mbr-006': ['data'] });

export const resetStore = () => {
  store.members = buildSeedMembers();
  store.roles = buildSeedRoles();
  store.groups = buildSeedGroups();
  store.studios = buildSeedStudios();
  store.directGrants = buildSeedDirectGrants();
  store.studioAccess = buildSeedStudioAccess();
  store.memberResources = buildSeedMemberResources();
  store.roleAssignments = {};
  store.importBatches = [];
  store.seq = 0;
};

/** Collision-free id for newly created mock records. */
export const nextId = (prefix) => {
  store.seq += 1;
  return `${prefix}-new-${store.seq}`;
};

resetStore();
